document.addEventListener('DOMContentLoaded', function () {
    var hero = document.querySelector('.hero');
    if (!hero) return;

    var slides = Array.prototype.slice.call(hero.querySelectorAll('.hero__slide'));
    var dotsWrap = document.getElementById('heroDots');
    var prevBtn = document.getElementById('heroPrev');
    var nextBtn = document.getElementById('heroNext');

    var current = 0;
    var autoplayDelay = 6000;
    var timer = null;

    slides.forEach(function (slide, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'hero__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', function () {
            goToSlide(i);
            restartAutoplay();
        });
        dotsWrap.appendChild(dot);
    });

    var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.hero__dot'));

    function setActive(index) {
        slides.forEach(function (slide, i) {
            slide.classList.toggle('is-active', i === index);
        });
        dots.forEach(function (dot, i) {
            dot.classList.toggle('is-active', i === index);
        });
        current = index;
    }

    function goToSlide(index) {
        var next = (index + slides.length) % slides.length;
        setActive(next);
    }

    function nextSlide() {
        goToSlide(current + 1);
    }

    function prevSlide() {
        goToSlide(current - 1);
    }

    function startAutoplay() {
        timer = window.setInterval(nextSlide, autoplayDelay);
    }

    function restartAutoplay() {
        window.clearInterval(timer);
        startAutoplay();
    }

    nextBtn.addEventListener('click', function () {
        nextSlide();
        restartAutoplay();
    });

    prevBtn.addEventListener('click', function () {
        prevSlide();
        restartAutoplay();
    });

    hero.addEventListener('mouseenter', function () {
        window.clearInterval(timer);
    });

    hero.addEventListener('mouseleave', function () {
        restartAutoplay();
    });

    var touchStartX = 0;
    hero.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    hero.addEventListener('touchend', function (e) {
        var touchEndX = e.changedTouches[0].screenX;
        var diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 50) {
            if (diff < 0) {
                nextSlide();
            } else {
                prevSlide();
            }
            restartAutoplay();
        }
    }, { passive: true });

    setActive(0);
    startAutoplay();
});